import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const servicesData = [
  {
    title: "Mutual Funds",
    path: "/mutual-funds",
    desc: "Diversified mutual fund investments with expert guidance.",
    icon: "/images/icons/nav-1.png",
    img: "/images/nav-menu/1.avif",
  },
  {
    title: "Equity & Commodity Trading",
    path: "/equity-commodity-trading",
    desc: "Trade equities and commodities with market insights.",
    icon: "/images/icons/nav-2.png",
    img: "/images/nav-menu/2.avif",
  },
  {
    title: "Depository Services",
    path: "/depository-services",
    desc: "Secure demat services for holding investment securities.",
    icon: "/images/icons/nav-3.png",
    img: "/images/nav-menu/3.avif",
  },
  {
    title: "Global Investments",
    path: "/global-investments",
    desc: "Access international markets for global portfolio diversification.",
    icon: "/images/icons/nav-4.png",
    img: "/images/nav-menu/4.avif",
  },
  {
    title: "Fixed Income Products",
    path: "/fixed-income-products",
    desc: "Stable returns through bonds and income securities.",
    icon: "/images/icons/nav-5.png",
    img: "/images/nav-menu/5.avif",
  },
  {
    title: "Insurance Products",
    path: "/insurance-products",
    desc: "Comprehensive insurance solutions for financial protection.",
    icon: "/images/icons/nav-6.png",
    img: "/images/nav-menu/6.avif",
  },
];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isBackdropVisible, setIsBackdropVisible] = useState(false);

  const location = useLocation();

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (isMobileMenuOpen) setIsSubMenuOpen(false);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
    setIsSubMenuOpen(false);
    setIsBackdropVisible(false);
  };

  const toggleSubMenu = (e) => {
    e.preventDefault();
    if (window.innerWidth < 992) {
      setIsSubMenuOpen(!isSubMenuOpen);
    }
  };

  return (
    <>
      {isBackdropVisible && (
        <div
          className="backdrop"
          style={{ display: "block" }}
          onClick={() => setIsBackdropVisible(false)}
        ></div>
      )}

      <header id="main-header" className="header my_header dropdownMu">
        <div id="top-header">
          <div className="container">
            <div className="row head-bg">
              <div className="col-lg-2 col-6 logo-box">
                <div className="logo">
                  <Link to="/" onClick={closeMenu}>
                    <img
                      src="/images/logo/logo.avif"
                      className="img-fluid"
                      alt="Gateway Financial Services Limited"
                    />
                  </Link>
                </div>
              </div>

              <div className="col-lg-10 col-6 align-self-center">
                <div
                  className={`overlay ${isMobileMenuOpen ? "active" : ""}`}
                  onClick={toggleMobileMenu}
                  aria-hidden="true"
                ></div>

                <nav className={`menu ${isMobileMenuOpen ? "active" : ""}`}>
                  <div
                    className={`menu-mobile-header ${isSubMenuOpen ? "active" : ""}`}
                  >
                    <button
                      type="button"
                      className="menu-mobile-arrow"
                      onClick={() => setIsSubMenuOpen(false)}
                      aria-label="Back to main menu"
                    >
                      <i className="ion ion-ios-arrow-back"></i>
                    </button>
                    <div className="menu-mobile-title"></div>
                    <button
                      type="button"
                      className="menu-mobile-close"
                      onClick={toggleMobileMenu}
                      aria-label="Close menu"
                    >
                      <i className="ion ion-ios-close"></i>
                    </button>
                  </div>

                  <ul className="menu-section text-left text-lg-right">
                    <li
                      className="single-item"
                      onMouseEnter={() => setIsBackdropVisible(false)}
                    >
                      <Link to="/" onClick={closeMenu}>
                        Home
                      </Link>
                    </li>
                    <li
                      className="single-item"
                      onMouseEnter={() => setIsBackdropVisible(false)}
                    >
                      <Link to="/why-us" onClick={closeMenu}>
                        Why Us
                      </Link>
                    </li>

                    <li
                      className="menu-item-has-children"
                      onMouseEnter={() =>
                        window.innerWidth >= 992 && setIsBackdropVisible(true)
                      }
                      onMouseLeave={() =>
                        window.innerWidth >= 992 && setIsBackdropVisible(false)
                      }
                    >
                      <a
                        href="#services"
                        role="button"
                        className="submenu-toggle-btn"
                        onClick={toggleSubMenu}
                        aria-expanded={isSubMenuOpen}
                        style={{
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        Our Services{" "}
                        <i className="ion ion-ios-arrow-down ml-1"></i>
                      </a>

                      <div
                        className="menu-subs menu-mega menu-column-3 tab tab2"
                        style={{
                          display:
                            isSubMenuOpen && window.innerWidth < 992
                              ? "block"
                              : "",
                        }}
                      >
                        <div className="tabHeader">
                          <div className="list-item">
                            <ul>
                              {servicesData.map((service, index) => (
                                <li
                                  key={index}
                                  className={`mb-6 pl-2 ${activeTab === index ? "active" : ""}`}
                                  onMouseEnter={() => setActiveTab(index)}
                                >
                                  <Link
                                    to={service.path}
                                    className="media"
                                    onClick={closeMenu}
                                  >
                                    <img
                                      src={service.icon}
                                      className="align-self-center mr-3"
                                      alt={`${service.title} Icon`}
                                    />
                                    <div className="media-body">
                                      <h5>{service.title}</h5>
                                      <p>{service.desc}</p>
                                    </div>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className="list-item menu-blog-box tabContent">
                          {servicesData.map((service, index) => (
                            <div
                              key={`img-${index}`}
                              className={`tabItem ${activeTab === index ? "active" : ""}`}
                            >
                              <img
                                src={service.img}
                                className={`img-fluid ${index === 0 ? "border-radius-10" : "mt-90"}`}
                                alt={service.title}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </li>

                    <li
                      className="single-item"
                      onMouseEnter={() => setIsBackdropVisible(false)}
                    >
                      <Link to="/open-an-account" onClick={closeMenu}>
                        Open An Account
                      </Link>
                    </li>
                    <li
                      className="single-item"
                      onMouseEnter={() => setIsBackdropVisible(false)}
                    >
                      <Link to="/partner-with-us" onClick={closeMenu}>
                        Partner With Us
                      </Link>
                    </li>
                    <li
                      className="single-item"
                      onMouseEnter={() => setIsBackdropVisible(false)}
                    >
                      <a
                        href="https://backoffice.gatewayfin.in/shrdbms/userlogin.ss"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={closeMenu}
                      >
                        Client Login
                      </a>
                    </li>
                    <li
                      className="single-item"
                      onMouseEnter={() => setIsBackdropVisible(false)}
                    >
                      <Link to="/contact-us" onClick={closeMenu}>
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </nav>

                <div className="header-item-right">
                  <button
                    type="button"
                    className="menu-mobile-trigger"
                    onClick={toggleMobileMenu}
                    aria-label="Open mobile menu"
                    aria-expanded={isMobileMenuOpen}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
